function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 2.922C1 1.861 1.86 1 2.922 1h10.156C14.139 1 15 1.86 15 2.922v10.156C15 14.139 14.14 15 13.078 15H2.922A1.922 1.922 0 011 13.078V2.922zm1.922-.979a.98.98 0 00-.979.98v10.155c0 .54.438.979.98.979h10.155a.98.98 0 00.979-.98V2.923a.98.98 0 00-.98-.979H2.923z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.058 5.461a.471.471 0 01-.142.337l-1.813 1.773a.472.472 0 01-.66-.674l.987-.964H6.146a.471.471 0 110-.943h4.284l-.986-.965a.472.472 0 11.659-.674l1.813 1.773c.091.089.142.21.142.337zm-1.813 5.078c0 .26-.211.471-.472.471H5.49l.987.965a.472.472 0 11-.66.674l-1.813-1.773a.472.472 0 010-.674l1.814-1.773a.472.472 0 01.659.674l-.987.964h4.284c.26 0 .472.211.472.472z"
}));
function SvgOperar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Operar.svg";
export { SvgOperar as ReactComponent };